
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import FAQ from '../pages/faq/page';
import FreeStrategyDoc from '../pages/free-strategy-doc/page';
import CustomTraining from '../pages/custom-training/page';
import RolePlay from '../pages/role-play/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/free-strategy-doc',
    element: <FreeStrategyDoc />,
  },
  {
    path: '/custom-training',
    element: <CustomTraining />,
  },
  {
    path: '/role-play',
    element: <RolePlay />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
